// src/utils/forms/languageHelper.js

import i18next from "i18next";

/**
 * ✅ Get initial language from localStorage or default
 * 
 * @returns {String} - 'ar' or 'en'
 */
export const getInitialLanguage = () => {
    const storedLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    return storedLang.startsWith("ar") ? "ar" : "en";
};

/**
 * ✅ Check if current language is Arabic
 * 
 * @param {Object} i18n - i18next instance
 * @returns {Boolean}
 */
export const isArabicLanguage = (i18n) => {
    const lng = i18n.language || "en";
    return lng === "ar";
};

/**
 * ✅ Toggle language between Arabic and English
 * 
 * @param {String} currentLang - Current language ('ar' or 'en')
 * @returns {String} - Toggled language
 */
export const toggleLanguage = (currentLang) => {
    return currentLang === 'ar' ? 'en' : 'ar';
};

/**
 * ✅ Get opposite language
 * 
 * @param {String} lang - Current language ('ar' or 'en')
 * @returns {String} - Opposite language
 */
export const getOppositeLanguage = (lang) => {
    return lang === 'ar' ? 'en' : 'ar';
};
